module.exports = __webpack_public_path__ + "images/login_icon_name@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/login_icon_name@2x.png
// module id = 879
// module chunks = 124